export const ADVISORY_SECTIONS = [
  "TECHNICAL ADVISORY COMMITTEE",
  "CONFERENCE ADVISORY COMMITTEE",
];

export const committeeStructure = [
  {
    section: "Chief Honorary Chair",
    members: [
      { name: "Maj Gen Parvinder Singh Sindhu", affiliation: "Chairman, AIT Pune" },
    ],
  },
  {
    section: "Honorary Chair",
    members: [
      { name: "Maj Gen Uday Shankar Sengupta [Retd]", affiliation: "Director, AIT Pune" },
    ],
  },
  {
    section: "Convenor",
    members: [
      { name: "Dr B P Patil", affiliation: "Principal, AIT Pune", email: "principal@aitpune.edu.in" },
      
    ],
  },
  {
    section: "Conference General Chair",
    members: [
     { name: "Prof(Dr) S R Dhore", affiliation: "HOD comp, AIT Pune", email: "hodcomp@aitpune.edu.in" },
    ],
  },
  {
    section: "General Co chair",
    members:[
       { name: "Dr NK Bansode", affiliation: "Prof, AIT Pune", email: "nkbansode@aitpune.edu.in" },
    ]
  },
  {
    section: "Conference Chair",
    members: [
      { name: "Dr Nikita Singhal", affiliation: "	Assistant Professor, AIT Pune", email: "ngupta@aitpune.edu.in" },
      { name: "Dr Sita Yadav", affiliation: "	Assistant Professor, AIT Pune", email: "syadav@aitpune.edu.in" },
    ],
  },
  {
    section: "TECHNICAL ADVISORY COMMITTEE",
    members: [
      { name: "Dr Amar Buchade", affiliation: "Chair IEEE Pune section"},
      { name: "Prof Abhijit Khurape", affiliation: "Secretary, IEEE Pune Section"},
      { name: "Dr Utpal Chakraborty", affiliation: "Founder & Chief Scientist, ExorionAI, Co-Founder & Chief Technology Officer-IndiqAI"},
      { name: "Dr Rajkumar Buyya", affiliation: "Director, Cloud Computing and Distributed Systems (CLOUDS) Lab, Professor at University of Melbourne"},
      { name: "Prof Dr G Raghvan", affiliation: "Professor and Director,School of Quanatum Technoology, DIAT"},
      { name: "Prof Dr Sunil Nair", affiliation: "Department of Physics, IISER Pune"},
      { name: "Dr Debasis De", affiliation: "Professor, MAKAUT, West Bengal"},
      { name: "Dr Anindita Banerjee", affiliation: "Project Manager for Quantum Technlogy Projects, Scientist CDAC Pune"},
      { name: "Dr Aswath Babu", affiliation: "Assistant Professor in Physics, HoD, Department of Arts, Science and Design, IIIT Dharwad, Dharwad"},
      { name: "Dr Dipti Saxena", affiliation: "Professor, MNIT Jaipur"},
      { name: "Dr Pilli Emmanuel Shubhakar", affiliation: "Professor MNIT Jaipur"},
      { name: "Dr Anirvan Gupta", affiliation: "assistant Professor, JSPM University, Pune"},
      { name: "Dr Amit Saxena", affiliation: "Scientist, CDAC Pune"},
      { name: "Dr Umakant Rapol", affiliation: "professor, ISSER Pune"},
      { name: "Dr Amit D. Joshi", affiliation: "Assistant Professor, COEP"},
      { name: "Dr Suraj Sawant", affiliation: "Assistant Professor, COEP"},
      { name: "Col Gaurav Upadhyay", affiliation: "Chief Operational Officer, Majine"},
      { name: "Dr Manisha Nene", affiliation: "Chief Technology Officer, Majine"},
    ],
  },
  {
    section: "CONFERENCE ADVISORY COMMITTEE",
    members: [
      { name: "Mr Ambarish Natu", affiliation: "Vice Chair, IEEE Australia Council,Comb"},
      { name: "Dr Pradeep Mane", affiliation: "Chair, Conference committee, IEEE Pune Section"},
      { name: "Dr Mandar Bhawalkar", affiliation: "Vice Chair, IEEE Pune Section"},
      
      { name: "Dr Sudeep Thepade", affiliation: "Pro vice chancellor PCU Pune"},
      { name: "Mr. Nilesh Dhande", affiliation: "CEO and co founder fourty two labs"},
      { name: "Mr. Vijendra Yadav", affiliation: "CEO - accops,Technical Advisory Committee"},
     
      { name: "Dr Pramod Patil", affiliation: "Dean Faculty of Science and Technology, SPPU"},
      { name: "Dr Nilesh Uke", affiliation: "Chairman Board of studies Computer Engineering"},
      { name: "Dr P N Mahalle", affiliation: "Dean Academics VIT Pune"},
    ],
  },
  {
    section: "Technical Program Chair",
    members: [
      { name: "Dr R Jayadevan", affiliation: "Associate Professor ,AIT Pune"},
      { name: "Dr Vaishali Ganganwar", affiliation: "Associate Professor ,AIT Pune"},
    ],
  },
  {
    section: "Conference Treasurer Chair",
    members: [
      { name: "Dr Nikita Singhal", affiliation: "Assistant Professor ,AIT Pune"},
      { name: "Dr Sita Yadav", affiliation: "Assistant Professor ,AIT Pune"},
    ],
  },
  {
    section: "Information Contact Chair",
    members: [
      { name: "Mr. Anup Kadam", affiliation: "Assistant Professor ,AIT Pune"},
      { name: "Mr. Mangesh Hajare", affiliation: "Assistant Professor ,AIT Pune"},
    ],
  },
  {
    section: "Publication Chair",
    members: [
      { name: "Dr Ganesh Mundhe", affiliation: "Associate Professor, AIT Pune"},
      { name: "Dr Sagar Rane", affiliation: "Associate Professor, AIT Pune"},
    ],
  },
  {
    section: "Publicity Chair",
    members: [
      { name: "Mr. MB Lonare", affiliation: "Assistant Professor, AIT Pune"},
      { name: "Ms Aarti Gangshetty", affiliation: "Assistant Professor, AIT Pune"},
    ],
  }
];

/* Track Chairs */
export const trackChairs = [
  { name: "	Dr N K Bansode", designation: "Professor" },
  { name: "Mr P R Sonawane", designation: "Assistant Professor" },
  { name: "Mrs Asha Sathe", designation: "Assistant Professor" },
  { name: "Dr Sharayu Lokhande", designation: "Assistant Professor" },
  { name: "	Ms Sushama A Shirke", designation: "Assistant Professor" },
  { name: "Ms Y T Hambir", designation: "Assistant Professor" },
];

/* Finance Chairs */
export const financeChairs = [
  { name: "Ms Rushali Katkar", designation: "Assistant Professor" },
  { name: "Ms Shreya Jare", designation: "Assistant Professor" },
];
